import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'capitalizeFirst'
})

export class CapitalizePipe implements PipeTransform {
    transform(value: string, args?: any[]): string {
        if (value === null) {
            return null;
        }
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/extra/capitalize.pipe.ts